<template>
  <section>
    <!-- Introduction -->
    <v-row>
      <v-col cols="12">
        <p>
          Also known to be the country of the vikings, Norway as become a very active territory after the discovery of petrol along the coast. With a population of 5 millions inhabitants for a surface area of 385.000 km², the country was able to keep its nature intact.
        </p>
        <p>
          Since 2016, I live in Norway which, in my opinion, is one of the top countries when it comes to photographing nature. As you will see, this place offers many different type of landscapes and environment.
        </p>
      </v-col>
    </v-row>
    <!-- Gallery -->
    <v-row>
      <v-col cols="12">
        <PortfolioGallery :img="list" />
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  data: () => {
    return {
      list: [
        {
          link: "/img/photos/Norway/0.jpg",
          title: "Viking's sunset",
          description: null
        },
        {
          link: "/img/photos/Norway/1.jpg",
          title: "A star in the sky",
          description: null
        },
        {
          link: "/img/photos/Norway/2.jpg",
          title: "A taste of freedom",
          description: null
        },
        {
          link: "/img/photos/Norway/3.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/4.jpg",
          title: "Autumn sky",
          description: null
        },
        {
          link: "/img/photos/Norway/5.jpg",
          title: "Barge's bark",
          description: null
        },
        {
          link: "/img/photos/Norway/6.jpg",
          title: "Beauty of frost",
          description: null
        },
        {
          link: "/img/photos/Norway/7.jpg",
          title: "Highway to the lake",
          description: null
        },
        {
          link: "/img/photos/Norway/8.jpg",
          title: "Power of nature",
          description: null
        },
        {
          link: "/img/photos/Norway/9.jpg",
          title: "Sky on fire",
          description: null
        },
        {
          link: "/img/photos/Norway/10.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/11.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/12.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/13.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/14.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/15.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/16.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/17.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/18.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/19.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/20.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/21.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/22.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/23.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/24.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/25.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/26.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/27.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/28.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/29.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/30.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/31.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/32.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/33.jpg",
          title: "No Title",
          description: null
        },
        {
          link: "/img/photos/Norway/34.jpg",
          title: "No Title",
          description: null
        },
      ]
    };
  },

  created() {
    this.$store.commit('SET_GALLERY_DATA', this.list)
  }
};
</script>

<style></style>
